import { TileCoordinate } from "@luciad/ria/model/tileset/TileCoordinate";
import { TileData } from "@luciad/ria/model/tileset/TileData";
import { UrlTileSetModel } from "@luciad/ria/model/tileset/UrlTileSetModel";

export class OGCAPIMapsModel extends UrlTileSetModel {

  _bboxCrs!: string;

  getTileURL(baseURL: string, tile: TileCoordinate): string | null {
    const tileBounds = this.getTileBounds(tile);
    const x2 = tileBounds.x + tileBounds.width;
    const y2 = tileBounds.y + tileBounds.height;
    const bbox = "bbox=" + tileBounds.x + "," + tileBounds.y + "," + x2 + "," + y2;
    const bboxCrs = "bbox-crs=" + encodeURIComponent(this._bboxCrs);
    // const bboxCrs = "bbox-crs=OGC:CRS84";
    // const tileUrl = baseURL + "?" + bboxCrs + "&" + bbox;
    const tileUrl = baseURL + "?" + bbox;

    return tileUrl;
  }

  set bboxCrs(newBboxCrs: string) {
    this._bboxCrs = newBboxCrs;
  };
}